import get from 'lodash.get';
import PropTypes from 'prop-types';
import React from 'react';
import ReactPlayer from 'react-player';

import PageSection from '../Common/PageSection';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import * as styles from './HalfAndHalfHeader.module.css';
import HeadingCtas from './HeadingCtas';

const HalfAndHalfHeader = ({ page }) => {
  const verticalBleed = page.headingStyle === 'Half and half with vertical bleed';
  return (
    <PageSection isTopSection={true} className={verticalBleed ? styles.verticalBleed : ''}>
      <div className={styles.grid}>
        <div className={styles.headingContent}>
          <h1 className={'homepage-h1'}>{page.heading}</h1>
          {page.headingIntroCopy?.raw && <RichTextConverter className={'homepage-lede'} copy={page.headingIntroCopy} />}
          {page.headingIntroCopy?.childMarkdownRemark && (
            <div
              className={'homepage-lede'}
              dangerouslySetInnerHTML={{ __html: page.headingIntroCopy?.childMarkdownRemark.html }}
            />
          )}
          {page.headingCtAs?.length > 0 && <HeadingCtas ctas={page.headingCtAs} />}
        </div>
        {!page.headingVideoUrl && (
          <img className={'homepage-hero'} src={get(page, 'headingImage.file.url')} alt={'hero'} />
        )}
        {page.headingVideoUrl && (
          <div className={styles.wistiaWrap}>
            <div className={`player-wrapper-${page.headingVideoUrl}`}>
              <ReactPlayer
                className={`react-player-${page.headingVideoUrl}`}
                width={'100%'}
                height="100%"
                controls={true}
                url={page.headingVideoUrl}
              />
            </div>
          </div>
        )}
      </div>
    </PageSection>
  );
};

HalfAndHalfHeader.propTypes = {
  /* Just pass the full page */
  page: PropTypes.object.isRequired,
};

export default HalfAndHalfHeader;
